import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  TextField,
  InputAdornment,
  Button,
  ButtonGroup,
} from '@mui/material';
import { useHistory, Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import {
  DetailDeliveryOrderHistory,
  // eslint-disable-next-line import/no-unresolved
} from 'components/Report/index';
import { ViewTitle } from '../../components/ViewTitle';
import * as actions from '../../redux/actions';
import Loading from '../../components/Loading';
import { Error } from '../../components/Error';
import VehicleScheduleTable from '../../components/Table/TMS/VehicleScheduleTable';
import BasicTabs from './TabfilterSchedule';
// import { SCHEDULE_STATUS } from '../../utils/constants';

const VehicleSchedules = ({ title, subtitle }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const vehicleSchedule = useSelector((state) => state.vehicleSchedule);
  const information = useSelector((state) => state.information);
  const [scheduleType, setScheduleType] = useState('');
  const [scheduleStatus, setScheduleStatus] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(undefined);

  const getVehicleSchedule = () =>
    dispatch(
      actions.vehicleScheduleAll({
        name,
        page,
        size,
        scheduleType,
        scheduleStatus,
      }),
    );

  useEffect(() => {
    getVehicleSchedule();
    return () => {};
  }, [name, page, size, scheduleType, scheduleStatus]);

  useEffect(() => {
    setTotal(vehicleSchedule?.total);
    return () => {};
  }, [vehicleSchedule]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setName(searchTerm);
      setPage(1);
    }, 700);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const tableProps = {
    page,
    size,
    total,
    handleChangePage: (evnet, newPage) => {
      setPage(newPage + 1);
    },
    handleChangeRowsPerPage: (event) => {
      setSize(event.target.value);
      setPage(1);
    },
    handlePending: async (id) => {
      try {
        const confirm = window.confirm(
          'ยืนยันการเปลี่ยนสถานะเป็น กำลังดำเนินการ',
        );
        if (confirm) {
          await dispatch(actions.vehicleSchedulePut(id, { pending: true }));
          getVehicleSchedule();
        }
      } catch (error) {
        alert('เปลี่ยนสถานะไม่ถูกต้อง', error?.message);
      }
    },
    handleComplete: async (id) => {
      try {
        const confirm = window.confirm('ยืนยันการเปลี่ยนสถานะเป็น สำเร็จ');
        if (confirm) {
          await dispatch(actions.vehicleSchedulePut(id, { completed: true }));
          getVehicleSchedule();
        }
      } catch (error) {
        alert('เปลี่ยนสถานะไม่ถูกต้อง', error?.message);
      }
    },
    handleBill: async (id) => {
      try {
        const confirm = window.confirm('ยืนยันการเปลี่ยนสถานะเป็น ออกบิลแล้ว');
        if (confirm) {
          await dispatch(actions.vehicleSchedulePut(id, { billed: true }));
          getVehicleSchedule();
        }
      } catch (error) {
        alert('เปลี่ยนสถานะไม่ถูกต้อง', error?.message);
      }
    },
    handleCancle: async (id) => {
      try {
        const confirm = window.confirm('ยืนยันการยกเลิกรายการเดินรถ');
        if (confirm) {
          await dispatch(actions.vehicleScheduleDelete(id, { deleted: true }));
          getVehicleSchedule();
        }
      } catch (error) {
        alert('เปลี่ยนสถานะไม่ถูกต้อง', error?.message);
      }
    },
    handleToEditPage: (id) => {
      history.push(`/tms/vehicle-schedule/edit/${id}`);
    },
    handleToInfoPage: (id) => {
      history.push(`/tms/vehicle-schedule/detail/${id}`);
    },
    handlePrintPdfDeliveryOrder: async (row, vehicleSchedule) => {
      await DetailDeliveryOrderHistory(row, information, vehicleSchedule);
    },
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const renderButton = () => (
    <div className="pb-4">
      <Link to={'/tms/vehicle-schedule/create'}>
        <Button variant="contained">เพิ่ม</Button>
      </Link>
    </div>
  );

  const renderSearchType = () => (
    // <div>
    <div className="flex flex-wrap">
      <ButtonGroup
        variant="outlined"
        aria-label="outlined button group"
        color="gray"
      >
        <Button onClick={() => setScheduleType('IMPORT')}>
          <div className="text-black">IMPORT</div>
        </Button>
        <Button onClick={() => setScheduleType('EXPORT')}>
          <div className="text-black">EXPORT</div>
        </Button>
        <Button onClick={() => setScheduleType('')}>
          <div className="text-black">ALL</div>
        </Button>
      </ButtonGroup>
    </div>
  );

  const renderSearch = () => (
    <Card>
      <div className="p-4 flex flex-row justify-between">
        <div className="w-full md:w-1/2">
          <TextField
            label="ค้นหา"
            fullWidth
            size="small"
            id="outlined-start-adornment"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search" />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="self-center">
          <div className="">{renderSearchType()}</div>
        </div>
      </div>
    </Card>
  );

  const renderTable = () => (
    <div className="my-2">
      <BasicTabs vehicleSchedule={vehicleSchedule} {...tableProps} />
    </div>
  );

  if (vehicleSchedule.isLoading) {
    return <Loading />;
  }

  if (!vehicleSchedule.isLoading && vehicleSchedule.isCompleted) {
    return (
      <div>
        <div className="flex justify-between">
          {renderTitle()}
          <div className="self-center">{renderButton()}</div>
        </div>

        {renderSearch()}
        {renderTable()}
      </div>
    );
  }
  return <Error />;
};

VehicleSchedules.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

VehicleSchedules.defaultProps = {
  title: '',
  subtitle: '',
};

export default VehicleSchedules;
